import React, { useContext } from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { firebaseAuth } from '../provider/AuthProvider';

export default function SessionStatus() {
  const { sessionStatus, sessionError, retrySession } = useContext(firebaseAuth);
  const failed = sessionStatus === 'error';
  return <main style={{ maxWidth: 520, margin: '48px auto', padding: 20 }}><Paper style={{ padding: 28 }}>
    <Typography component="h1" variant="h5">{failed ? 'We couldn’t restore your session' : 'Checking your session…'}</Typography>
    {failed ? <><Typography role="alert" style={{ margin: '20px 0' }}>{sessionError}</Typography>
      <Button variant="contained" color="primary" onClick={retrySession}>Try again</Button>
      <Button component={Link} to="/">Back to Options</Button></> : <Typography role="status" style={{ marginTop: 20 }}>Please wait a moment.</Typography>}
  </Paper></main>;
}
